import { render, staticRenderFns } from "./chips.vue?vue&type=template&id=4171ef52&scoped=true&"
import script from "./chips.vue?vue&type=script&lang=js&"
export * from "./chips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4171ef52",
  null
  
)

export default component.exports